export default {
  SameAsAuthorisedSignatory: "SameAsAuthorisedSignatory",
  NewSignatory: "NewSignatory",
  NotRequired: "NotRequired",
};
